module.exports = __webpack_public_path__ + "static/media/env-map-day-4k.f88d1658.hdr";